module.exports = __webpack_public_path__ + "static/media/garena.994616c3.png";